import { apiInterfaceForJson } from '../common/apiManager';

export const getReflexRules = (params = {}) => {
    return apiInterfaceForJson('/reflexRule/v1/', 'GET', params);
};

export const getReflexRuleById = (id) => {
    return apiInterfaceForJson('/reflexRule/v1/' + id, 'GET');
};

export const addReflexRule = (data) => {
    return apiInterfaceForJson('/reflexRule/v1/', 'POST', data);
};

export const updateReflexRule = (id, data) => {
    return apiInterfaceForJson('/reflexRule/v1/' + id, 'PUT', data);
};

export const deleteReflexRule = (id) => {
    return apiInterfaceForJson('/reflexRule/v1/' + id, 'DELETE');
};

export const checkReflexRules = (data) => {
    return apiInterfaceForJson('/reflexRule/v1/check', 'POST', data);
};

export const executeReflexRule = (ruleId, orderId) => {
    return apiInterfaceForJson('/reflexRule/v1/execute', 'POST', { ruleId, orderId });
};
